export enum EMainRoutes {
	DASHBOARD = '',
	CATALOG = 'catalog',
	MY_OFFERS = 'my_offers',
	OFFER = 'offer',
	SOURCES = 'sources',
	CREATE = 'create',
	EDIT = 'edit',
	FINANCES = 'finances',
	REPORTS = 'reports',
	ACCOUNT = 'account',
	LOG_IN = 'login',
	LOG_OUT = 'logout',
	NOTIFICATIONS = 'notifications',
	PROFILE = 'profile',
	VERIFICATION = 'verification',
	TOOLS = 'tools',
	API = 'api',
	BROKEN_LINKS = 'broken_links',
	POSTBACKS = 'postbacks',
	SHORTLINK = 'shortlink',
	TELEGRAM = 'telegram',
	TOKEN = 'token',
	LINKS = 'links',
	REFERRALS = 'referrals',
}
